/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2022
 *
 *==================================================
 */
export const SELLERS_GET = "SELLERS_GET";
export const SELLERS_GET_SUCCESS = "SELLERS_GET_SUCCESS";
export const SELLERS_GET_FAILURE = "SELLERS_GET_FAILURE";
export const SET_SELLER = "SET_SELLER";
export const SET_SELLER_SUCCESS = "SET_SELLER_SUCCESS";
export const SET_SELLER_FAILURE = "SET_SELLER_FAILURE";
